import { ThemePlusTypes } from "@styles/types";
import { PalletThemeColors } from "@styles/utils";

export default (colors: PalletThemeColors): ThemePlusTypes["featuredCard"] => {
  return {
    background: colors.green.lightest, // FeaturedCard not used in PLUS
    color: colors.primary.darkest,
  };
};
